import { render, staticRenderFns } from "./InformarChamadoCriado.vue?vue&type=template&id=9c08cb60"
import script from "./InformarChamadoCriado.vue?vue&type=script&lang=js"
export * from "./InformarChamadoCriado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports